import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    schemaText: {
        fontFamily: 'Roboto',
        fontStyle: "normal",
        fontWeight: "500",
        fontSize: "18px",
        lineHeight: "26px",
        marginTop:"45px",
        // textAlign: "center",
        letterSpacing: "-0.001em",
        color: "#091E42",
    }
}));